import { render, staticRenderFns } from "./WidgetData.vue?vue&type=template&id=624334b8&scoped=true"
import script from "./WidgetData.vue?vue&type=script&lang=js"
export * from "./WidgetData.vue?vue&type=script&lang=js"
import style0 from "./WidgetData.vue?vue&type=style&index=0&id=624334b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624334b8",
  null
  
)

export default component.exports